import { render, staticRenderFns } from "./InputDadosPessoais.vue?vue&type=template&id=15fd1f67"
import script from "./InputDadosPessoais.vue?vue&type=script&lang=js"
export * from "./InputDadosPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports